<template>
  <div>
    <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.link }">
      <input type="text" placeholder="Ссылка на товар дешевле" class="form-control form-control--white"
        v-model="contact.link">
      <p class="invalid-feedback" v-if="errors.link">
        {{ errors.link.join(', ') }}</p>
    </div>

    <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.name }">
      <input type="text" class="form-control form-control--white" placeholder="Ваше имя" v-model="contact.name">
      <p class="invalid-feedback" v-if="errors.name">
        {{ errors.name.join(', ') }}
      </p>
    </div>
    <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.phone }">
      <input type="text" class="form-control form-control--white" v-model="contact.phone" v-mask="'+7(###)###-##-##'"
        placeholder="+7(xxx)xxx-xx-xx">
      <p class="invalid-feedback" v-if="errors.phone">
        {{ errors.phone.join(', ') }}</p>
    </div>

    <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.email }">
      <input type="text" placeholder="Email для ответа" class="form-control form-control--white"
        v-model="contact.email">
      <p class="invalid-feedback" v-if="errors.email">
        {{ errors.email.join(', ') }}</p>
    </div>

    <div class="form-group form__group" v-bind:class="{ 'is-invalid': errors.message }">
      <textarea rows="2" placeholder="Комментарий или вопрос" class="form-control form-control--white"
        v-model="contact.message"></textarea>
      <p class="invalid-feedback" v-if="errors.message">
        {{ errors.message.join(', ') }}</p>
    </div>

    <input type="hidden" v-model="contact.content_type">
    <p class="invalid-feedback" v-if="errors.content_type">
      {{ errors.content_type.join(', ') }}</p>

    <input type="hidden" v-model="contact.object_id">
    <p class="invalid-feedback" v-if="errors.object_id">
      {{ errors.object_id.join(', ') }}</p>

    <div class="form__actions">
      <button type="button" class="btn btn-primary accept-btn modal__accept-btn w-100"
        v-on:click="sendForm">Отправить</button>
      <p class="form-accept__text text-center mt-2">Отправляя вы принимаете <a href="/legal/">условия</a>
        обработки персональных данных</p>
    </div>
  </div>
</template>
<script>
export default {

  name: 'LessPriceRequestForm',

  components: {

  },

  props: {
    contact: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
    }
  },

  mounted() {

  },

  methods: {
    sendForm() {
      this.$emit("send-form", this.contact)
    }
  },

}
</script>


<style lang="scss"></style>
